import { configureStore } from "@reduxjs/toolkit";
import { contentReducer } from "./reducers/contents";

export default configureStore({
  reducer: {
    content: contentReducer,
  },
});
